module.exports = __webpack_public_path__ + "img/image-modal-warning.0d2b5276.svg";